import React from 'react';

const OfferDetailNoFormat = ({ name, value }) => (
  <div className="w-full">
    <ul className="leaders">
      <li className="text-left pb-4">
        <span>
          {name}
          :
        </span>
        {' '}
        <span className="font-bold">{value}</span>
      </li>
    </ul>
  </div>
);

export default OfferDetailNoFormat;
